import { FormattedMessage } from "react-intl";

const MultiChannelSupport = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.multiChannelSupport.content.body"
                    defaultMessage="Employees and customers can submit requests via email, Microsoft Teams and Slack, an embedded widget, or a customer portal."
                />
            </p>
        </div>
    );
};

export default MultiChannelSupport;
